var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3818_3173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.52555 7.50603L3.17633 8.16047L6.83296 4.54106L3.21358 0.880759L2.55916 1.52786L5.53144 4.53375L2.52555 7.50603Z",
    fill: "#098D83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3818_3173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6193 7.50603L7.27008 8.16047L10.9267 4.54106L7.30733 0.880759L6.65291 1.52786L9.62519 4.53375L6.6193 7.50603Z",
    fill: "#89E8E1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3818_3173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7131 7.50603L11.3638 8.16047L15.0205 4.54106L11.4011 0.880759L10.7467 1.52786L13.7189 4.53375L10.7131 7.50603Z",
    fill: "#D7FFFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_3173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.82401,
    height: 8.82401,
    fill: "white",
    transform: "translate(9.07422 8.9657) rotate(-179.678)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3818_3173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.82401,
    height: 8.82401,
    fill: "white",
    transform: "translate(13.168 8.9657) rotate(-179.678)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3818_3173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.82401,
    height: 8.82401,
    fill: "white",
    transform: "translate(17.2617 8.9657) rotate(-179.678)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.dfae350ba506ed30d79f5f5102ffbb19.svg";
export { ForwardRef as ReactComponent };